import { render, staticRenderFns } from "./ModalCopyUrl.vue?vue&type=template&id=4ecfe4d2&scoped=true"
import script from "./ModalCopyUrl.vue?vue&type=script&lang=js"
export * from "./ModalCopyUrl.vue?vue&type=script&lang=js"
import style0 from "./ModalCopyUrl.vue?vue&type=style&index=0&id=4ecfe4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecfe4d2",
  null
  
)

export default component.exports